import { render } from "./TheComments.vue?vue&type=template&id=6280a27c&scoped=true"
import script from "./TheComments.vue?vue&type=script&lang=js"
export * from "./TheComments.vue?vue&type=script&lang=js"

import "@/assets/styles/comments.scss?vue&type=style&index=0&id=6280a27c&scoped=true&lang=scss"

import exportComponent from "/home/djokic/Projects/mariv/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6280a27c"]])

export default __exports__